/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { riskBlocksGet } from "../funcs/riskBlocksGet.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { RiskBlock } from "../models/components/riskblock.js";
import {
  GetRiskBlockRequest,
  GetRiskBlockSecurity,
} from "../models/operations/getriskblock.js";
import { unwrapAsync } from "../types/fp.js";
export type RiskGetBlockQueryData = RiskBlock;

export function prefetchRiskGetBlock(
  queryClient: QueryClient,
  client$: GramCore,
  request: GetRiskBlockRequest,
  security?: GetRiskBlockSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildRiskGetBlockQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildRiskGetBlockQuery(
  client$: GramCore,
  request: GetRiskBlockRequest,
  security?: GetRiskBlockSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<RiskGetBlockQueryData>;
} {
  return {
    queryKey: queryKeyRiskGetBlock({
      id: request.id,
      gramSession: request.gramSession,
    }),
    queryFn: async function riskGetBlockQueryFn(
      ctx,
    ): Promise<RiskGetBlockQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(riskBlocksGet(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyRiskGetBlock(
  parameters: { id: string; gramSession?: string | undefined },
): QueryKey {
  return ["@gram/client", "blocks", "get", parameters];
}
